import * as yup from 'yup';
import { enabledValidation, imageValidation } from 'utils/yup';
import { TFunction } from 'i18next';

const maxFileSize = 50 * 1024; // 50 KB

export default (t: TFunction): any =>
  yup.object({
    priorityOverCommerce: enabledValidation(t),
    cashEnabled: enabledValidation(t),
    balanceEnabled: enabledValidation(t),
    activeProvider: yup.number().positive(),
    firstDataConfigId: yup.string(),
    mpConfigId: yup.string(),
    mpCheckoutConfigId: yup.string(),
    mpPointConfigId: yup.string(),
    // cloverPointConfigId: yup.string(),
    izipayConfigId: yup.string(),
    sitefConfigId: yup.string(),
    enableCustomQrScreenAspect: yup.boolean(),
    fiservQrScreenLetterColor: yup.mixed().when('enableCustomQrScreenAspect', {
      is: true,
      then: yup.string().required(t('venuePaymentConfig-form-qr-aspect-required-color')),
    }),
    fiservQrScreenQrBorderColor: yup.mixed().when('enableCustomQrScreenAspect', {
      is: true,
      then: yup.string().required(t('venuePaymentConfig-form-qr-aspect-required-color')),
    }),
    fiservQrScreenBorderColor: yup.mixed().when('enableCustomQrScreenAspect', {
      is: true,
      then: yup.string().required(t('venuePaymentConfig-form-qr-aspect-required-color')),
    }),
    fiservQrScreenBackgroundColor: yup.mixed().when('enableCustomQrScreenAspect', {
      is: true,
      then: yup.string().required(t('venuePaymentConfig-form-qr-aspect-required-color')),
    }),
    fiservQrScreenLogo: imageValidation('Custom logo', false, t, maxFileSize),
  });
